import VimeoPlayer from "@vimeo/player";
import { useCallback } from "react";

import { logException, trackEvent } from "utils";

export const useVimeoTracking = (eventName: string) => {
  const playerRef = useCallback(
    (node: HTMLIFrameElement) => {
      if (node === null) {
        return;
      }
      const onPlay = () => {
        trackEvent(`${eventName} video played`);
      };

      const onPause = () => {
        trackEvent(`${eventName} video paused`);
      };

      const onEnd = () => {
        trackEvent(`${eventName} video ended`);
      };

      try {
        const player = new VimeoPlayer(node);
        player.on("play", onPlay);
        player.on("pause", async () => {
          // pause event is automatically triggered when the video has completely ended.
          // so we check if the video has ended so we do not call the trackEvent for paused.
          const ended = await player.getEnded();
          if (ended) {
            onEnd();
          }
          onPause();
        });
      } catch (err) {
        // eat errors, we just won't track the video events
        logException(err);
      }
    },
    [eventName],
  );

  return playerRef;
};
